import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import LoginForm from './components/LoginForm';
import SocialLoginButton from './components/SocialLoginButton';
import SecurityBadge from './components/SecurityBadge';

const Login = () => {
  const navigate = useNavigate();

  const handleSocialLogin = (provider) => {
    console.log(`Attempting login with ${provider}`);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-card rounded-2xl shadow-lg p-6 md:p-8 lg:p-10">
          <div className="text-center mb-6 md:mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-primary/10 rounded-2xl mb-4 md:mb-6">
              <Icon name="Sparkles" size={32} color="var(--color-primary)" />
            </div>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground mb-2">
              Welcome Back
            </h1>
            <p className="text-muted-foreground caption text-sm md:text-base">
              Sign in to continue your journey on Nubi
            </p>
          </div>

          <LoginForm />

          <div className="relative my-6 md:my-8">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-border"></div>
            </div>
            <div className="relative flex justify-center">
              <span className="bg-card px-4 caption text-muted-foreground text-xs md:text-sm">
                Or continue with
              </span>
            </div>
          </div>

          <div className="space-y-3 md:space-y-4">
            <SocialLoginButton
              provider="Google"
              icon="Chrome"
              onClick={() => handleSocialLogin('Google')}
            />
            <SocialLoginButton
              provider="Facebook"
              icon="Facebook"
              onClick={() => handleSocialLogin('Facebook')}
            />
          </div>

          <div className="mt-6 md:mt-8 text-center">
            <p className="caption text-muted-foreground text-sm md:text-base">
              Don't have an account?{' '}
              <button
                onClick={() => navigate('/register')}
                className="text-primary font-medium hover:underline transition-base"
              >
                Create Account
              </button>
            </p>
          </div>

          <div className="mt-6 md:mt-8 pt-6 border-t border-border">
            <SecurityBadge />
          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="caption text-muted-foreground text-xs md:text-sm">
            By signing in, you agree to our{' '}
            <button className="text-primary hover:underline">Terms of Service</button>
            {' '}and{' '}
            <button className="text-primary hover:underline">Privacy Policy</button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;